import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Button, Message, Header } from 'semantic-ui-react';

const PolicyVerification = (props) => {
	let errorMessage;
	if (props.error) {
		const content = Array.isArray(props.error) ? props.error.map((e, index) => <div key={index}>{`${e}`}</div>) : props.error;
		errorMessage = <Message error header='Verification Failed' content={content} />;
	}
	const { data } = props;

	const showDLN = useMemo(() => data.policyNumber && data.policyNumber.toUpperCase().startsWith('PPA'), [data.policyNumber]);
	const showDOB = useMemo(() => data.policyNumber && (data.policyNumber.toUpperCase().startsWith('HOM') || data.policyNumber.toUpperCase().startsWith('PUP')), [data.policyNumber]);

	const isValid = useMemo(() => {
		let valid = true;
		if (data.verifiedPart1) {
			if (showDLN && (!data.driversLicenseNumber || data.driversLicenseNumber === '')) valid = false;
			if (showDOB && (!data.dateOfBirth || data.dateOfBirth === '')) valid = false;
			if (!data.zip || data.zip === '' || data.zip.length !== 5) valid = false;
		}

		return valid;
	}, [data, showDLN, showDOB]);

	return (
		<Container>
			<Form onSubmit={props.onSubmit} loading={props.loading} error>
				<Header as='h1' textAlign='center' content='Policy Verification' />
				<Header as='h4' content='Fill in the fields below to verify your policy.' />
				<Form.Field>
					<input name='policyNumber' placeholder='Policy Number' onChange={props.onChange} value={data.policyNumber || ''} />
				</Form.Field>
				<Form.Field>
					<input name='policyHolder' placeholder='Policyholder' onChange={props.onChange} value={data.policyHolder || ''} />
				</Form.Field>
				{data.verifiedPart1 && data.policyNumber && (
					<>
						{showDLN && (
							<Form.Field>
								<input name='driversLicenseNumber' placeholder='Drivers License Number (no dashes) ' onChange={props.onChange} value={data.driversLicenseNumber || ''} />
							</Form.Field>
						)}

						{showDOB && (
							<Form.Field>
								<input name='dateOfBirth' placeholder='Date of Birth (MM/DD/YYYY)' onChange={props.onChange} value={data.dateOfBirth || ''} />
							</Form.Field>
						)}

						<Form.Field>
							<input name='zip' placeholder='Billing Zip Code (5 digits)' onChange={props.onChange} value={data.zip || ''} type="text" />
						</Form.Field>
					</>
				)}
				{errorMessage}
				<Button basic fluid type='submit' disabled={!isValid}>
					VERIFY
				</Button>
			</Form>
		</Container>
	);
};

PolicyVerification.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	data: PropTypes.object.isRequired,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default PolicyVerification;
